import React, { useCallback } from 'react'
import FormDataEditor from '../json-form-object-editor'

function AdaptorField({ value, schema, onChange }: { value?: any; schema: any; onChange?: any }) {
  const localOnChange = useCallback(({ formData }) => onChange(formData), [onChange])
  return <FormDataEditor formData={value} schema={schema} onChange={localOnChange} />
}

AdaptorField.displayName = 'AdaptorField'
export default AdaptorField
